import React, { HTMLAttributes } from 'react'

import { withOptimizely, WithOptimizelyProps } from '@optimizely/react-sdk'
import { Column, Grid, ProductionNearMeRow } from '@vividseats/vivid-ui-kit'
import { ProductionNearMeRowType } from '@vividseats/vivid-ui-kit/dist/components/production-near-me-row'
import NextLink from 'next/link'

import VariantProductionNearMeRowWithBadging from '@/optimizely/components/variant-production-near-me-row-with-badging'

interface ProductionNearMeListingType extends HTMLAttributes<HTMLAnchorElement> {
    isHomeOpener?: boolean
    isLowPricesDealsAvailable?: boolean
    isSellingFast?: boolean
    productionId: number
    productionNearMeRowProps: ProductionNearMeRowType
}

const ProductionNearMeListing: React.FC<ProductionNearMeListingType & WithOptimizelyProps> = ({
    isHomeOpener,
    isLowPricesDealsAvailable,
    isSellingFast,
    productionId,
    productionNearMeRowProps,
}) => {
    const { href } = productionNearMeRowProps
    const productionNearMeRow: JSX.Element = (
        <Column>
            <NextLink href={href || '/#'} passHref>
                {isHomeOpener || isLowPricesDealsAvailable || isSellingFast ? (
                    <VariantProductionNearMeRowWithBadging
                        {...productionNearMeRowProps}
                        isHomeOpener={isHomeOpener}
                        isLowPricesDealsAvailable={isLowPricesDealsAvailable}
                        isSellingFast={isSellingFast}
                        data-testid={`production-near-me-row-${productionId}`}
                    />
                ) : (
                    <ProductionNearMeRow
                        {...productionNearMeRowProps}
                        data-testid={`production-near-me-row-${productionId}`}
                    />
                )}
            </NextLink>
        </Column>
    )

    return <Grid key={productionId}>{productionNearMeRow}</Grid>
}

export default withOptimizely(ProductionNearMeListing)
